import { ThunkExtraArgument } from '../../../../shared/config/storeConfig/StoreSchema'
import { configureStore } from '@reduxjs/toolkit'
import { $API } from '../../../../shared/api/api'
import { roleReducer } from '../../../../entities/Role'
import { userReducer } from '../../../../entities/User'
import { modalReducer } from '../../../../entities/Modal'
import { loginReducer } from '../../../../pages/LoginPage'
import { commonReducer } from '../../../../entities/Common'
import { clientReducer } from '../../../../entities/Client'
import { productReducer } from '../../../../entities/Product'
import { appReducer } from '../../../../entities/Application'
import { licenseReducer } from '../../../../entities/License'
import { commentsReducer } from '../../../../entities/Comment'
import { authUserReducer } from '../../../../entities/AuthUser'
import { instancesReducer } from '../../../../entities/Instances'
import { clientLabelReducer } from '../../../../entities/ClientLabel'
import { licenseEventsReducer } from '../../../../entities/LicenseEvents'
import { notificationsReducer } from '../../../../entities/Notifications'
import { presetsReducer } from '../../../../entities/FunctionalityPreset'
import { functionalitiesReducer } from '../../../../entities/Functionality'
import { licenseUpdatesReducer } from '../../../../entities/LicenseUpdates'
import { instanceEventsReducer } from '../../../../entities/InstanceEvents'
import { productPublicKeyReducer } from '../../../../features/GetProductPublicKey'
import { similarNamesReducer } from '../../../../features/DisplaySimilarNames'
import { newApplicationReducer } from '../../../../features/AddNewApplication'
import { newClientLabelReducer } from '../../../../features/AddNewClientLabel'
import { clientLabelsReducer } from '../../../../features/DisplayClientLabels'
import { addNewPresetReducer } from '../../../../features/AddNewPreset'
import { newProductReducer } from '../../../../features/AddNewProduct'
import { newLicenseReducer } from '../../../../features/AddNewLicense'
import { newClientReducer } from '../../../../features/AddNewClient'
import { newUserReducer } from '../../../../features/AddNewUser'
import {
	addFunctionalitiesReducer
} from '../../../../features/AddFunctionalitiesToProduct'
import { appSecretKeyReducer } from '../../../../widgets/ApplicationSecretKey'
import { licensesReducer } from '../../../../pages/LicensesPage'
import { productsReducer } from '../../../../pages/ProductsPage'
import { clientsReducer } from '../../../../pages/ClientsPage'
import { usersReducer } from '../../../../pages/UsersPage'
import { appsReducer } from '../../../../pages/AppsPage'

const ThunkExtraArg: ThunkExtraArgument = {
	api: $API
}

export const store = configureStore({
	reducer: {
		authUser: authUserReducer,
		user: userReducer,
		client: clientReducer,
		license: licenseReducer,
		licenseUpdates: licenseUpdatesReducer,
		licenseEvents: licenseEventsReducer,
		instanceEvents: instanceEventsReducer,
		instances: instancesReducer,
		product: productReducer,
		application: appReducer,
		applicationSecretKey: appSecretKeyReducer,
		comment: commentsReducer,
		modal: modalReducer,
		newUserState: newUserReducer,
		newClientState: newClientReducer,
		newProductState: newProductReducer,
		newLicenseState: newLicenseReducer,
		newApplicationState: newApplicationReducer,
		notifications: notificationsReducer,
		users: usersReducer,
		clients: clientsReducer,
		loginState: loginReducer,
		licenses: licensesReducer,
		products: productsReducer,
		applications: appsReducer,
		commonData: commonReducer,
		productKey: productPublicKeyReducer,
		newFunctionalities: addFunctionalitiesReducer,
		functionalities: functionalitiesReducer,
		functionalitiesPresets: presetsReducer,
		newPreset: addNewPresetReducer,
		similarCompanyNames: similarNamesReducer,
		newUserRole: roleReducer,
		newClientLabel: newClientLabelReducer,
		clientLabels: clientLabelsReducer,
		clientLabel: clientLabelReducer
	},
	devTools: process.env.NODE_ENV === 'development',
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			thunk: {
				extraArgument: ThunkExtraArg
			}
		})
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
